import React from "react";
import NewsFeedSkeleton from "./ProductDashboard/NewsFeed/NewsFeedSkeleton";
import ChartSkeleton from "./ProductDashboard/Charts/ChartSkeleton";
import SidebarSkeleton from "./Common/SidebarSkeleton";
import FilterBarSkeleton from "./Common/FilterbarSkeleton";
const DashboardSkeleton = () => {
  return (
    <>
      <div className="d-flex bg-custom " style={{ height: "100vh" }}>
        <div>
          <SidebarSkeleton />
        </div>
        <div
          className="flex-grow-1"
          style={{ overflow: "auto", height: "100%" }}
        >
          <div className="flex " style={{ height: "8%" }}>
            <FilterBarSkeleton />
          </div>
          <div
            className="p-3 bg-white rounded-4 rounded-left"
            style={{ height: "92%" }}
          >
            <ChartSkeleton />
            <NewsFeedSkeleton />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardSkeleton;
